import React from "react";
import "./App.css";
import Navb from "./nav";
import Home from "./Home";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Projects from "./Projects";
import Skills from "./Skills";
import Internships from "./Interns";
import Certification from "./certifications";

function App() {
  React.useEffect(() => {
    window.location.replace("https://manitej.rocks/");
  }, []);
  return null;
  // <Router>
  //   <div className="App">
  //     <Navb />
  //     <Route exact path="/" component={Home} />
  //     <Route path="/projects" component={Projects} />
  //     <Route path="/skills" component={Skills} />
  //     <Route path="/interns" component={Internships} />
  //     <Route path="/awards" component={Certification} />
  //   </div>
  // </Router>
}

export default App;
